module.exports = __webpack_public_path__ + "img/laravel-icon.4d361af1.svg";